import { Box, Typography } from '@mui/material';
import MusicOff from '@mui/icons-material/MusicOff';

export function EmptyState({ message }: { message: string }) {
    return (
        <Box className="flex flex-col items-center gap-3 py-16 text-center text-gray-400">
            <MusicOff sx={{ fontSize: 48 }} />
            <Typography variant="body1">{message}</Typography>
        </Box>
    );
}
